import { getEnv } from "./env";

/**
 * Check if the environment is development.
 */
export const isDevelopment = getEnv<boolean>("DEV");
